import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useUpdateDegree } from 'app/react-query/hook/degree'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IPayloadUpdateDegree, IProps } from './type'

export const useHook = ({ degree }: IProps) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IPayloadUpdateDegree>()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncUpdate, isLoading } =
    useUpdateDegree()

  useEffect(() => {
    form?.setFieldsValue({
      name: degree?.name,
      description: degree?.description,
      code: degree?.code
    })
  }, [degree])

  const handleSubmit = async (values: IPayloadUpdateDegree) => {
    const newData: IPayloadUpdateDegree = {
      id: degree?.id,
      ...values
    }

    await mutateAsyncUpdate?.(newData)
    modalRef?.current?.hide?.()
    form?.resetFields()
    notificationController.success({
      message: t(R.strings.success),
    })
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
  }
}
